
import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noInternalWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value ?? '';
  const hasInternalSpace = /\s/.test(value);
  return hasInternalSpace ? { internalWhitespace: true } : null;
}